/* Nordlivo: tilføjer "Skriv dig op"-knappen øverst til højre i headeren (dansk/engelsk) */
(function () {
  var isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var label = isEn ? 'Sign up' : 'Skriv dig op';
  var href = (isEn ? '/en' : '') + '/pages/skriv-dig-op';

  function addCta() {
    var actions = document.querySelector('#header-component header-actions');
    if (!actions || actions.querySelector('.nordlivo-header-cta')) return;
    var link = document.createElement('a');
    link.className = 'nordlivo-header-cta';
    link.href = href;
    link.textContent = label;
    actions.appendChild(link);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addCta);
  } else {
    addCta();
  }
  document.addEventListener('shopify:section:load', addCta);
  new MutationObserver(addCta).observe(document.documentElement, { childList: true, subtree: true });
})();
